import React from "react";
import {
  FaGithub,
  FaLinkedin,
  FaTwitter,
  FaFacebook,
  FaInstagram

} from "react-icons/fa";
import { FiMail } from "react-icons/fi";
import { SiMedium } from "react-icons/si";

const social = {
  copyright: `Copyright © ${new Date().getFullYear()} Shubham Verma.`,
  author: {
    name: "Shubam Verma",
    accounts: [
      {
        url: "https://www.linkedin.com/in/shubham-verma-78768a157/",
        name: "LinkedIn",
        type: "linkedin",
        icon: <FaLinkedin />,
      },
      {
        url: "https://github.com/S-hub1996",
        name: "Github",
        type: "gray",
        icon: <FaGithub />,
      },
      {
        url: "https://www.sv7836832607@gmail.com",
        name: "Mail",
        type: "red",
        icon: <FiMail />,
      },
      {
        url: "https://twitter.com/be_yourhighness",
        name: "Twitter",
        type: "blue",
        icon: <FaTwitter />,
      },
      {
        url: "https://medium.com/@shubhamkashayapverma",
        name: "Medium",
        type: "black",
        icon: <SiMedium />,
      },
      {
        url: "https://www.instagram.com/sinner_since96/",
        name: "Instagram",
        type: "pink",
        icon: <FaInstagram />,
      },
      {
        url: "https://www.facebook.com/skv301",
        name: "Facebook",
        type: "facebook",
        icon: <FaFacebook />,
      },
    ],
  },
};

export default social;